import { useQuery, useQueryClient } from "@tanstack/react-query";
import { queryCommonFlags } from "@/api/constants";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";
import {
  getCustomerIdInfo,
  updateCustomerIdInfo,
} from "@/modules/property-tracks/api/customer-id-info";
import { UpdateCustomerIdInfoDTO } from "@/modules/property-tracks/dtos/customer-id-info";

export const useCustomerIdInfo = ({
  customerUid,
}: {
  customerUid?: string;
}) => {
  const query = useQuery({
    queryKey: ["customer-id-info", customerUid],
    queryFn: () => getCustomerIdInfo(customerUid || ""),
    enabled: !!customerUid,
    ...queryCommonFlags,
  });

  return {
    ...query,
    data: query.data?.data,
  };
};

export const useUpdateCustomerIdInfo = () => {
  const queryClient = useQueryClient();

  return useDomainMutation<
    unknown,
    { response?: { data?: { message?: string } } },
    { uid: string; data: UpdateCustomerIdInfoDTO }
  >({
    mutationFn: ({ uid, data }) => updateCustomerIdInfo(uid, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["customer-id-info"] });
    },
  });
};
